'use client';

import { useMicrocopy } from '@contexts/MicrocopyContext';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { Modal } from 'ui-components';
import { PriceFacet } from '../PriceFacet';
import { PublisherFacet } from '../PublisherFacet';
import { RatingFacet } from '../RatingFacet';
import { ReleaseDateFacet } from '../ReleaseDateFacet';
import { FiltersDrawerProps } from './FiltersDrawer.types';

export const FiltersDrawer = ({ isOpen, onClose }: FiltersDrawerProps) => {
  const { searchLabelsMicrocopy } = useMicrocopy<{
    searchLabelsMicrocopy: MicrocopyFragment[];
  }>();

  const getLabel = (key: string, fallback: string) =>
    searchLabelsMicrocopy?.find((m) => m.key === key)?.value ?? fallback;

  if (!isOpen) return null;

  return (
    <Modal
      title={getLabel('search.filters.title', 'All Filters')}
      closeLabel={getLabel('search.filters.close', 'Close')}
      isActive={isOpen}
      closeModal={onClose}
      size="small"
    >
      <div className="flex flex-col border-t border-grey-500">
        <PriceFacet variant="drawer" />
        <RatingFacet variant="drawer" />
        <PublisherFacet variant="drawer" />
        <ReleaseDateFacet variant="drawer" />
      </div>
    </Modal>
  );
};
